import Sonda from '@bit/gerenciatd.utils.front-sonda';
import {
  compareIfFirstProductGreaterThanSecond,
  getSelectedProductOfGroup,
} from '../../../utils/productUtils';

/**
 * Obtiene la info final para el modal de retención
 * @param {object} infoForRetentionModal información apra el modal de retención
 * @param {object} group grupo del producto a contratar
 * @param {object} groupProductsHired Producto contratado
 * @returns {object}
 */
export const getFinalInfoForRetentionModal = (
  infoForRetentionModal,
  group,
  groupProductsHired,
  fromFicha = false
) => {
  let result = infoForRetentionModal;

  result = {
    ...result,
    aliasProduct: getSelectedProductOfGroup(group),
    hiredAliasProduct: getSelectedProductOfGroup(groupProductsHired),
    isDowngrade:
      !fromFicha
      && getSelectedProductOfGroup(group) !== ''
      && getSelectedProductOfGroup(groupProductsHired) !== ''
        ? !compareIfFirstProductGreaterThanSecond(
          group[getSelectedProductOfGroup(group)],
          groupProductsHired[getSelectedProductOfGroup(groupProductsHired)]
        )
        : false,
  };
  return result;
};

export const handlePreventionBehaviour = (
  isPrevention,
  downGradeOnclikcHandler,
  url,
  Modal,
  context
) => {
  try {
    if (isPrevention) {
      downGradeOnclikcHandler();
    } else {
      window.location.href = `${url}&pid=clic-boton-meinteresa-flyout-retention`;
      Modal.hide();
    }
  } catch (error) {
    const info = 'No se ha podido calcular el comportamiento de la modal de retencion';
    const sonda = new Sonda({
      processName: 'RetentionModalUtils',
      context,
      filePath: 'components/RetentionModal',
    });
    sonda.warningMessage({ info, error });
  }
};
